(function () {
  if (window.innerWidth >= 768) return;

  const PAGINATION_SELECTOR = '.pagination';
  const NEXT_PAGE_SELECTOR = '.pagination__item--prev';
  const PRODUCT_LIST_SELECTOR = '#product-grid';
  const PRODUCT_GRID_SELECTOR = '#ProductGridContainer';

  let loading = false;
  let observer = null;

  // Injeta o CSS do spinner uma única vez
  const style = document.createElement('style');
  style.textContent = `
    #is-spinner {
      display: none;
      justify-content: center;
      align-items: center;
      padding: 24px 0;
    }
    #is-spinner.visible {
      display: flex;
    }
    #is-spinner svg {
      animation: is-spin 0.8s linear infinite;
      width: 32px;
      height: 32px;
      color: currentColor;
      opacity: 0.5;
    }
    @keyframes is-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    @media (max-width: 767px) {
      .pagination {
        visibility: hidden;
      }
    }
  `;
  document.head.appendChild(style);

  // Cria o elemento spinner
  const spinner = document.createElement('div');
  spinner.id = 'is-spinner';
  spinner.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4" stroke-dashoffset="10" stroke-linecap="round"/>
    </svg>
  `;

  function getNextPageUrl() {
    const link = document.querySelector(NEXT_PAGE_SELECTOR);
    return link ? link.href : null;
  }

  function appendProducts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newItems = doc.querySelectorAll(`${PRODUCT_LIST_SELECTOR} > li`);
    const currentList = document.querySelector(PRODUCT_LIST_SELECTOR);
    if (!currentList || !newItems.length) return;

    newItems.forEach((item) => currentList.appendChild(item));

    const newPagination = doc.querySelector(PAGINATION_SELECTOR);
    const currentPagination = document.querySelector(PAGINATION_SELECTOR);
    if (currentPagination) currentPagination.remove();

    if (newPagination) {
      document.querySelector(PRODUCT_GRID_SELECTOR).appendChild(newPagination);
      observeSentinel();
    }
  }

  async function loadNextPage() {
    if (loading) return;
    const url = getNextPageUrl();
    if (!url) return;

    loading = true;

    // Mostra spinner antes do fetch
    const grid = document.querySelector(PRODUCT_GRID_SELECTOR);
    if (grid) {
      grid.appendChild(spinner);
      spinner.classList.add('visible');
    }

    try {
      const response = await fetch(url);
      const html = await response.text();
      appendProducts(html);
    } catch (e) {
      console.error('[IS] Erro:', e);
    } finally {
      spinner.classList.remove('visible');
      loading = false;
    }
  }

  function observeSentinel() {
    if (observer) observer.disconnect();

    const pagination = document.querySelector(PAGINATION_SELECTOR);
    if (!pagination) return;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadNextPage();
        });
      },
      { rootMargin: '200px' }
    );

    observer.observe(pagination);
  }

  function init() {
    if (!document.querySelector(NEXT_PAGE_SELECTOR)) return;
    observeSentinel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
